import type H from '@here/maps-api-for-javascript';

import { Defer } from '@mopla/utils';

export type { H };

// Module cache
let hereModuleDefer: Defer<typeof H> | null = null;

/**
 * Get HERE Maps SDK instance
 * Uses dynamic import to keep the SDK out of the main bundle
 * Caches the module after first load
 */
export async function getH(): Promise<typeof H> {
	if (hereModuleDefer) {
		return hereModuleDefer.promise;
	}

	const _hereModuleDefer = new Defer<typeof H>();

	try {
		const module = await import('@here/maps-api-for-javascript');
		_hereModuleDefer.resolve(module.default);
	} catch (e) {
		_hereModuleDefer.reject(e);
	}

	hereModuleDefer = _hereModuleDefer;

	return hereModuleDefer.promise;
}
